<div class="logo-container"
     [ngClass]="{ 'vatra': customConfig.title === 'TheVatra' }"

>
  <img src="{{ customConfig.homeLogo }}"
       [ngClass]="{ 'sirius': isSirius }"
       alt=""
       class="logo"
  >
  <span *ngIf="!isSirius && customConfig.roomName" title="{{ janusService.getLocalUserId() }}">{{roomName}}</span>
  <span class="users">
    <stusan-icon icon="users" class="users__icon"></stusan-icon>
    <span>{{ usersNumber }}</span>
  </span>
</div>
<div class="live">
<!--  <span class="live__record"></span>-->
  {{ meetingDuration }}
</div>
<div class="layouts" *ngIf="customConfig.layout">
  View:
  <button class="layouts__item layouts__item--share"
          [class.layouts__item--active]="(stateService.layoutType$ | async) === layoutTypeEnum.share"
          (click)="setLayoutType(layoutTypeEnum.share)"
  >
    <stusan-icon icon="layout-share"></stusan-icon>
  </button>

<!--  <button class="layouts__item layouts__item&#45;&#45;leader"-->
<!--          [class.layouts__item&#45;&#45;active]="(stateService.layoutType$ | async) === layoutTypeEnum.leader"-->
<!--          (click)="setLayoutType(layoutTypeEnum.leader)"-->
<!--  >-->
<!--    <stusan-icon icon="layout-leader"></stusan-icon>-->
<!--  </button>-->

  <button class="layouts__item"
          [class.layouts__item--active]="(stateService.layoutType$ | async) === layoutTypeEnum.tile"
          (click)="setLayoutType(layoutTypeEnum.tile)"
  >
    <stusan-icon icon="layout-tile"></stusan-icon>
  </button>

  <!-- <button class="layout-dropdown-arrow">
    <stusan-icon icon="circle-arrow-down"></stusan-icon>
  </button> -->
</div>
